import { render, staticRenderFns } from "./BlockType114.vue?vue&type=template&id=350fa0ac&scoped=true"
import script from "./BlockType114.vue?vue&type=script&lang=ts"
export * from "./BlockType114.vue?vue&type=script&lang=ts"
import style0 from "./BlockType114.vue?vue&type=style&index=0&id=350fa0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350fa0ac",
  null
  
)

export default component.exports